var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.5625C9.54594 18.5625 11.8125 16.2959 11.8125 13.5C11.8125 10.7041 9.54594 8.4375 6.75 8.4375C3.95406 8.4375 1.6875 10.7041 1.6875 13.5C1.6875 16.2959 3.95406 18.5625 6.75 18.5625Z",
    stroke: "white",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18.5625C23.0459 18.5625 25.3125 16.2959 25.3125 13.5C25.3125 10.7041 23.0459 8.4375 20.25 8.4375C17.4541 8.4375 15.1875 10.7041 15.1875 13.5C15.1875 16.2959 17.4541 18.5625 20.25 18.5625Z",
    stroke: "white",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.5625H20.25",
    stroke: "white",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.103c189d7f7805aa8eb45ded49cacc72.svg";
export { ForwardRef as ReactComponent };